import IComponentButton from "react-common-components/dist/components/Button/interface";
import { ICalendarEvent } from "react-common-components/dist/components/Calendar/interface";

export interface IFiltersCalendar{
    responsible?: string;
    filter?: string;
    startDate?:string;
    endDate?:string;
}

export interface IEventContainer{
    type:EventType;
}

export interface ICalendarFilter extends IComponentButton{
    isActive:boolean;
}

export interface IScoreEvent extends ICalendarEvent{
    responsible?:string;
    responsibleName:string;
    responsibleImage:string;
    traceability:string;
    eventType:EventType;
}

export enum EventType{
    ACTION = 1,
    OCCURRENCE = 2,
    AUDIT = 3,
    REUNIONS = 4
}
